<template>
  <vue-seamless-scroll
    :data="list"
    class="seamless-warp"
    :class-option="classOption"
  >
    <ul class="carousel_ul">
      <li class="carousel_li" v-for="(item, index) in list" :key="index">
        <el-tooltip
          class="item"
          effect="dark"
          :content="item.siteName"
          :open-delay="1000"
          placement="top-start"
        >
          <span class="title information-title"> {{ item.siteName }}</span>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          :content="item.alarmContent"
          :open-delay="1000"
          placement="top-start"
        >
          <span class="comment-title information-title">
            {{ item.alarmContent }}</span
          >
        </el-tooltip>
        <span class="title"> {{ item.createTime.substring(0, 10) }}</span>
        <span
          class="title"
          :class="[
            { pro_1: item.status === 1 || item.status === 3 },
            { pro_2: item.status === 2 || item.status === 4 },
            { pro_3: item.status === 5 || item.status === 6 }
          ]"
        >
          {{ item.status | valueName("alarmStatus") }}</span
        >
      </li>
    </ul>
  </vue-seamless-scroll>
</template>
<script>
export default {
  props: ["list"],
  data() {
    return {
      name: "无缝轮播-注意只能用span"
    };
  },
  computed: {
    classOption() {
      return {
        step: 0.5, // 数值越大速度滚动越快
        limitMoveNum: 5, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        // openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      };
    }
  }
};
</script>
<style scoped>
.seamless-warp {
  width: 100%;
  height: 70%;
  overflow: hidden;
}

.carousel_ul {
  margin: 0;
  padding: 0;
}

.carousel_li {
  display: flex;
  padding-right: 0.5%;
  width: 100%;
  height: 2vh;
  line-height: 2vh;
  background-size: 100% !important;
  color: #bdf3f6;
  margin-bottom: 1.6vh;
  font-size: 1.6vh;
}

.carousel_li .title {
  padding: 0 1% 0 2%;
  width: 20%;
}

.carousel_li .comment-title {
  padding: 0;
  width: 30%;
  text-align: left;
}

.carousel_li .information-title {
  overflow: hidden; /*溢出的部分隐藏*/
  white-space: nowrap; /*文本不换行*/
  text-overflow: ellipsis; /*ellipsis:文本溢出显示省略号（...）；clip：不显示省略标记（...），而是简单的裁切*/
}

.carousel_li .ovr_h {
  width: 51%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/*未开始*/
.carousel_li .pro_1 {
  color: #f89d2e;
}

/*进行中*/
.carousel_li .pro_2 {
  color: #00fcd8;
}

/*已完成*/
.carousel_li .pro_3 {
  color: #3cff45;
}
</style>



// WEBPACK FOOTER //
// src/components/html/listScroll.vue